import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { EntityDataServiceAccessorService } from '@pit/core-data';
import { EntityStoreEffects } from '@pit/core-store';
import { IDtoResourceFault } from '@pit/frontend-model';
import { Observable } from 'rxjs';
import { DtoResourceFaultStoreFactory } from './dto.resource.fault.store.factory';

@Injectable()
export class DtoResourceFaultEffects extends EntityStoreEffects<IDtoResourceFault> {

    constructor(actions$: Actions, dataServiceAccessor: EntityDataServiceAccessorService) {
        super('dto.resource.fault', actions$, DtoResourceFaultStoreFactory.instance, dataServiceAccessor);
    }

    loadForMandatorByResourceType$: Observable<Action> = DtoResourceFaultStoreFactory.instance.getEffect('get.by.mandator.resourcetype')(this.actions$, this.dataServiceAccessor);

}
